import React from 'react';
import { Spinner } from 'react-bootstrap';
import './backdrop.scss';

const ResponceForAPI = ({ show, message = '' }) => (
  <div className={`backdropRes ${show ? 'show' : ''}`}>

    <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <div className="custom-loader"></div>
      <span className='fs-4 mt-5 text-center text-black font-w600 mx-4'>{message}</span>
    </span>
  </div>
);

export default ResponceForAPI;